import React, { useEffect, useRef } from "react";
import { message } from "antd";
import { useWarehouseModel } from "../warehouseModel";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText } from "@/utils/utils"
import { IVRMWarehouseInsert } from "../warehouseTypes";
import useGlobalModel from "@/model/globalModel";
import { debounce } from "lodash";
import { useDictModel } from '@/views/base/dict/dictModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'

export function AddDetailDrawer() {
    const { user: { userName }} = useGlobalModel();
    const { getSelectedDictOne } = useDictModel()
    const { addWareVisible: visible, setAddWaerVisible, insertWarehouse } = useWarehouseModel();
    const formRef = useRef<IYhFormRef>();

    const onCancel = () => {
        setAddWaerVisible(false);
    }
    useEffect(() => {
        formRef.current?.setFieldsValue({status:1})
    }, [visible]);
    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {

            // let data={...res,status:res.status?1:0,createUser: userName}
            let data={...res,status:res.status?1:0}
            insertWarehouse(data as IVRMWarehouseInsert).then(res => {
                res && onCancel()
            })
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "仓库编码",
                fieldName: "code",
                span: 24,
                disable:true,
                placeholder:'自动生成'
                // rules: [{ required: true, message: "请输入仓库编码" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "仓库名称",
                fieldName: "name",
                span: 24,
                rules: [{ required: true, message: "请输入仓库名称" }]
            },
            // {
            //     type: FormItemTypeEnum.Select,
            //     fieldLabel: '仓库类型',
            //     fieldName: 'vehicleModelCode',
            //     options: getSelectedDictOne(DictCodeEnmu.VEHICLE_TYPE),
            //     span: 24,
            // },
             {
                type: FormItemTypeEnum.Input,
                fieldLabel: "仓库负责人",
                fieldName: "contact",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系地址",
                fieldName: "address",
                span: 24,
            },  {
                type: FormItemTypeEnum.Switch,
                fieldLabel: '仓库状态',
                fieldName: 'status',
                checkedChildren: '启用',
                unCheckedChildren: '禁用',
                span: 24,
            },
        ]
    };
    return (
        <YHDrawer
            {...{
                title: "仓库新增",
                visible,
                onCancel,
                okText: "保存",
                onOk: debounce(() => { onSubmit() }, 900)

            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}
